import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';

import BaseQos from '../../AbstractObjects/GatewayPlan/InnerPages/BaseQos';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {qosIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.qos;
const pageId = pageSchema.pageId;

function GatewayQos({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData([pageId, pageSchema.manageInSmp], planPage[pageSchema.manageInSmp]);
            setGatewayData([pageId, pageSchema.mode], planPage[pageSchema.mode]);
            setGatewayData([pageId, pageSchema.lowLatency], planPage[pageSchema.lowLatency]);
            setGatewayData([pageId, pageSchema.lowLatency], planPage[pageSchema.lowLatency]);
            setGatewayData([pageId, pageSchema.guarantee], planPage[pageSchema.guarantee]);
            setGatewayData([pageId, pageSchema.guaranteeTraffic], planPage[pageSchema.guaranteeTraffic]);
            setGatewayData([pageId, pageSchema.guaranteePercentage], planPage[pageSchema.guaranteePercentage]);
            setGatewayData([pageId, pageSchema.limitApps], planPage[pageSchema.limitApps]);
            setGatewayData([pageId, pageSchema.limitAppsUpload], planPage[pageSchema.limitAppsUpload]);
            setGatewayData([pageId, pageSchema.limitAppsDownload], planPage[pageSchema.limitAppsDownload]);
            setGatewayData([pageId, pageSchema.limitUploadSize], planPage[pageSchema.limitUploadSize]);
            setGatewayData([pageId, pageSchema.limitDownloadSize], planPage[pageSchema.limitDownloadSize]);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMC_GATEWAYSEC_RULES_QOS')}
            icon={qosIcon}
        >
            <BaseQos
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.QoSOverview')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.QOS')}</SMCLink>
        </Indentation>
        </>
    );
}

export default GatewayQos;